/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Required_SkillsInputs */

const en_jobs_required_skills = /** @type {(inputs: Jobs_Required_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required Skills`)
};

const de_jobs_required_skills = /** @type {(inputs: Jobs_Required_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erforderliche Fähigkeiten`)
};

const fr_jobs_required_skills = /** @type {(inputs: Jobs_Required_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compétences requises`)
};

const es_jobs_required_skills = /** @type {(inputs: Jobs_Required_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilidades requeridas`)
};

const it_jobs_required_skills = /** @type {(inputs: Jobs_Required_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competenze richieste`)
};

const nl_jobs_required_skills = /** @type {(inputs: Jobs_Required_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereiste vaardigheden`)
};

const pl_jobs_required_skills = /** @type {(inputs: Jobs_Required_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wymagane umiejętności`)
};

const fi_jobs_required_skills = /** @type {(inputs: Jobs_Required_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaaditut taidot`)
};

const da_jobs_required_skills = /** @type {(inputs: Jobs_Required_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Påkrævede færdigheder`)
};

const sv_jobs_required_skills = /** @type {(inputs: Jobs_Required_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nödvändiga färdigheter`)
};

/**
* | output |
* | --- |
* | "Required Skills" |
*
* @param {Jobs_Required_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_required_skills = /** @type {((inputs?: Jobs_Required_SkillsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Required_SkillsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_required_skills(inputs)
	if (locale === "fr") return fr_jobs_required_skills(inputs)
	if (locale === "es") return es_jobs_required_skills(inputs)
	if (locale === "it") return it_jobs_required_skills(inputs)
	if (locale === "nl") return nl_jobs_required_skills(inputs)
	if (locale === "pl") return pl_jobs_required_skills(inputs)
	if (locale === "fi") return fi_jobs_required_skills(inputs)
	if (locale === "da") return da_jobs_required_skills(inputs)
	if (locale === "sv") return sv_jobs_required_skills(inputs)
	return en_jobs_required_skills(inputs)
});